import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { format as formatDate } from 'date-fns';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { convertDate } from 'src/utils/transformation';

const OfflineSupplierCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;

  const intl = useInternationalization();
  const value = useMemo(() => dataItem?.[field], [dataItem, field]);

  const formattedDate = useMemo(
    () =>
      field === 'statusDate' || field === 'creationDate'
        ? formatDate(convertDate(dataItem?.[field]), 'MM/dd/yyyy')
        : '',
    [dataItem, field]
  );

  const formattedDollor = useMemo(
    () => (field === 'poTotal' ? intl.format('{0:c2}', Number(dataItem?.[field]) || 0) : 0),
    [dataItem, field, intl]
  );

  const formattedValue = useMemo(
    () =>
      field === 'statusDate' || field === 'creationDate'
        ? formattedDate
        : field === 'poTotal'
        ? formattedDollor
        : value,
    [field, formattedDate, formattedDollor, value]
  );

  return (
    <GridCellBase {...props} title={formattedValue} rowSelectionEnabled={true}>
      {formattedValue}
    </GridCellBase>
  );
};

export default OfflineSupplierCell;
